"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _CreditsMenuItem = require("./CreditsMenuItem.style");
var _Link = _interopRequireDefault(require("../Link"));
var _Text = _interopRequireDefault(require("../Text"));
const TextComponent = _ref => {
  var _data$credits;
  let {
    data,
    isMobile
  } = _ref;
  const textProps = {
    type: isMobile ? 'Body' : 'ButtonText',
    variant: isMobile ? 'BoldBlack' : 'Primary'
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Text.default, Object.assign({}, textProps, {
    intlText: "HeaderMenus.Main.CreditsUsage"
  })), data.loading ? /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "credits-usage-skeleton"
  }, /*#__PURE__*/_react.default.createElement(_CreditsMenuItem.CreditCountSkeleton, {
    width: 60
  })) : /*#__PURE__*/_react.default.createElement(_Text.default, Object.assign({}, textProps, {
    text: "".concat((data === null || data === void 0 ? void 0 : (_data$credits = data.credits) === null || _data$credits === void 0 ? void 0 : _data$credits.count) || 0)
  })));
};
const TextComponentWrapper = _ref2 => {
  let {
    data,
    isMobile
  } = _ref2;
  if (!isMobile) return /*#__PURE__*/_react.default.createElement(TextComponent, {
    data: data
  });
  return /*#__PURE__*/_react.default.createElement(_CreditsMenuItem.CreditsUsageWrapper, {
    "data-testid": "credits-usage"
  }, /*#__PURE__*/_react.default.createElement(TextComponent, {
    data: data,
    isMobile: true
  }));
};
const CreditsUsage = _ref3 => {
  let {
    link,
    data,
    isMenuItem,
    isMobile
  } = _ref3;
  if (isMenuItem) {
    return /*#__PURE__*/_react.default.createElement(TextComponentWrapper, {
      data: data,
      isMobile: isMobile
    });
  }
  return (
    /*#__PURE__*/
    // @ts-ignore
    _react.default.createElement(_Link.default, {
      to: link
    }, /*#__PURE__*/_react.default.createElement(TextComponentWrapper, {
      data: data,
      isMobile: isMobile
    }))
  );
};
var _default = exports.default = CreditsUsage;